module.exports = __webpack_public_path__ + "img/national.f4bcb284.png";